import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { T } from '../traks';
import {dataPlaceholder} from '../misc'
import { site_name } from '../Site';

const getLink = () => {
    return "#";  
}

//Component to display key figures for a stock
export const KeyFigures = (info) => {
  const link = getLink();
    return (
      <div className='py-4'>
      <div className="ad_key_figures">
        <div className='d-flex ad_company_info_card_header px-3'>
          <h1 className='mt-3 ad_text_white'><T>Key Figures</T></h1>
        </div>
        <div className='d-flex flex-wrap mt-4'>
          <Card className='ad_key_figures_card col-sm-12 col-md-6 col-xl-4 mb-4'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1 className='ad_text_white'>
                <T>BETA</T>
                </h1>
              </div>
              <p>
              {dataPlaceholder(info.beta)}
              </p>
            </CardBody>
          </Card>
          <Card className='ad_key_figures_card col-sm-12 col-md-6 col-xl-4 mb-4'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1 className='ad_text_white'>
                <T>ROIC (Return on Invested Capital)</T>
                </h1>
              </div>
              <p>
              {dataPlaceholder(info.efficiencyRatios ? info.efficiencyRatios.ROIC : '')}
              </p>
            </CardBody>
          </Card>
          <Card className='ad_key_figures_card col-sm-12 col-md-6 col-xl-4 mb-4'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1 className='ad_text_white'>
                <T>P/E (Price/Earnings)</T>
                </h1>
              </div>
              <p>
              {dataPlaceholder(info.valuationRatios ? info.valuationRatios.PE : '')}
              </p>
            </CardBody>
          </Card>
          <Card className='ad_key_figures_card col-sm-12 col-md-6 col-xl-4 mb-4'>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <h1 className='ad_text_white'>
                <T>ROE (Return on Equity)</T>
                </h1>
              </div>
              <p>
              {dataPlaceholder(info.efficiencyRatios ? info.efficiencyRatios.ROE : '')}
              </p>
            </CardBody>
          </Card>
        </div>
      </div>
      </div>
    );
  };
  


// WEBPACK FOOTER //
// ./src/c/KeyFigures.js